import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow, MaskLines } from "@/components/Motion";

export const Why = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section ref={ref} data-testid="why-section" className="relative overflow-hidden bg-[#0F2138] py-24 lg:py-32">
      <div className="grain" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Eyebrow light>{t.home.whyEyebrow}</Eyebrow>
          <h2 className="mt-6 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
            <MaskLines lines={[t.home.whyTitle]} onView />
          </h2>
          <div className="relative mt-10 aspect-[4/5] overflow-hidden">
            <motion.img style={{ y, scale: 1.2 }} src="/img/stacker.jpg" alt="Reach stacker in a container yard" loading="lazy" className="h-full w-full object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" aria-hidden="true" />
            <span className="absolute bottom-0 start-0 h-1 w-24 bg-[#C59B27]" aria-hidden="true" />
          </div>
        </div>
        <ol className="lg:col-span-7 lg:pt-28">
          {t.home.why.map((w, i) => (
            <Reveal as="li" key={w.t} delay={i * 0.08} className="group grid grid-cols-[auto,1fr] gap-6 border-t border-white/15 py-10 last:border-b sm:gap-10" data-testid={`why-item-${i}`}>
              <span className="w-12 font-serif text-5xl leading-none text-[#C59B27] sm:w-16 sm:text-6xl" dir="ltr">{String.fromCharCode(97 + i)}.</span>
              <div>
                <h3 className="font-serif text-2xl text-white sm:text-3xl">{w.t}</h3>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-[#C9D4E1]">{w.d}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
